<app-header [inFolderView]="true" [hidden]="!!entityId"></app-header>
<router-outlet></router-outlet>
